/**
 * R12 — guarda da tela "Assine seu contrato" (`/contrato`), fora do DashboardLayout (sem
 * menu: nao ha para onde ir antes de assinar). Mesmo predicado do `DashboardLayout`
 * (`needsContract`) nas duas direcoes, entao nao ha ping-pong.
 *
 * Reativo de proposito: ao assinar, a pagina relê o `/auth/me` e `contract_required` cai;
 * este gate leva o aluno para a home (nao ha tela de confirmacao a preservar).
 */
import { useEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { LoadingOverlay } from '@/components/ui'
import { useAuthStore } from '@/stores/authStore'
import { useThemeInit } from '@/stores/uiStore'
import { needsContract, nextPathForUser } from './onboardingAccess'

export function ContractGate() {
  const { user, isAuthenticated, isLoading, checkAuth } = useAuthStore()

  useThemeInit()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  if (isLoading && !user) {
    return <LoadingOverlay message="Carregando..." />
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />
  }

  // Plano e onboarding vem antes; sem contrato pendente, a home.
  if (!needsContract(user)) {
    return <Navigate to={nextPathForUser(user)} replace />
  }

  return <Outlet />
}
